module.exports = __webpack_public_path__ + "img/petstairs30.2612a324.jpg";